module.exports = __webpack_public_path__ + "media/excellusbcbs-app-page@xs-1edd4bebc8619327f61a3b054b69f3f6.jpg";